module.exports = __webpack_public_path__ + "static/img/packets_search.3974bd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/packets_search.svg
// module id = dgTO
// module chunks = 1